import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import queryString from 'query-string';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { Card, CardContent, Typography, Box, Link } from '@mui/material';
import { resetPasswordRequest } from '../../../redux/ducks/UserDucks';

import { ResetPasswordForm } from '../../input/ResetPasswordForm/ResetPasswordForm';
import { Footer } from '../../layout/Footer';
import { useStyles } from './ResetPasswordPage.styles';
import useIsDesktop from '../../../hooks/useIsDesktop/useIsDesktop';

export function ResetPasswordPage() {
  const isDesktop = useIsDesktop();
  const classes = useStyles({ isDesktop });
  const dispatch = useDispatch();
  const location = useLocation();
  const query = queryString.parse(location?.search);
  // Auth Hub appends `?token=<token>` to the redirect_url it emails. If
  // the user lands here without one (link tampered with, copy/paste cut
  // it off, manual navigation) we must NOT show the form — there is no
  // way to complete the reset and we'd POST `token: undefined` to the
  // hub. Show an actionable invalid-link panel instead.
  const token = typeof query.token === 'string' ? query.token : '';

  const isLoading = useSelector((state) => state.user.isLoading);
  const resetError = useSelector((state) => state.user.resetError);

  const onSubmit = (data) => {
    dispatch(resetPasswordRequest({ password: data.password, token }));
  };

  const passwordError =
    resetError && resetError.field === 'password' ? resetError.message : null;
  const bannerError =
    resetError && resetError.field !== 'password' ? resetError.message : null;

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={classes.rootcontainer}
      >
        <Card className={classes.card} variant="outlined">
          <CardContent className={classes.cardContent}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="stretch"
            >
              <Grid item xs={12}>
                <Grid container>
                  <Grid item lg>
                    {token ? (
                      <ResetPasswordForm
                        onSubmit={onSubmit}
                        isLoading={isLoading}
                        passwordError={passwordError}
                        bannerError={bannerError}
                      />
                    ) : (
                      <Box
                        data-testid="reset-password:invalid-link"
                        textAlign="center"
                        py={2}
                      >
                        <Typography component="h1" variant="h5" gutterBottom>
                          Invalid or expired link
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          This password reset link is invalid or has expired.
                        </Typography>
                        <Box mt={2}>
                          <Link
                            component={RouterLink}
                            to="/forgot-password"
                            data-testid="reset-password:request-new-link"
                          >
                            Request a new reset link
                          </Link>
                        </Box>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Footer />
    </>
  );
}
